<template>
    <div id="i-want">
        <div class="title">我要核销</div>
        <div 
            class="content" 
            v-loading="loading" 
            element-loading-text="核销中···"
            element-loading-spinner="el-icon-loading"
        >
            <div class="i-want-form">
                <div v-for="(item, index) in list" :key="index" class="form-body">
                    <span style="min-width: 100px;">电子码{{ index+1 }}：</span>
                    <el-input v-model="item.used_code" style="width: 400px;" placeholder="请输入电子码"></el-input>
                    <span style="margin-left: 48px; min-width: 85px;">身份证号：</span>
                    <el-input v-model="item.card_no" style="width: 400px;" placeholder="请输入身份证号"></el-input>
                    <template v-if=" index == 0">
                        <div class="circle-plus-outline">
                            <i class="el-icon-circle-plus-outline icon_cursor" @click="onAdd"></i>
                        </div>
                    </template>
                    <template v-else>
                        <div class="remove-outline">
                            <i class="el-icon-remove-outline icon_cursor2" @click="onRemove(index)"></i>
                        </div>
                    </template>
                </div>
            </div>
            <div class="bottom-button">
                <el-divider></el-divider>
                <div style="align-self: flex-end;">
                    <el-button @click="batchUpload">批量上传</el-button>
                    <el-button type="primary" @click="writeOff">核 销</el-button>
                </div>
            </div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="writeOffDialog"
            class="dialog1"
            width="30%"
        >
            <p style="text-align: center;">是否对电子码{{ show_list.join('、') }}进行核销？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="writeOffDialog = false" size="small">取 消</el-button>
                <el-button type="primary" @click="sureWriteOff" size="small">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            v-loading="loading"
            title="上传文件"
            @close="closeUpload"
            :visible.sync="uploadDialog"
            width="40%"
        >
            <el-upload
                class="upload-demo"
                ref="upload"
                action="#"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :auto-upload="false"
                :file-list="fileList"
                :limit="1"
                accept=".xls,.xlsx,.csv"
            >
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>    
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="fileSubmit"
                    size="small"
                >
                开始上传
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { writeOff, uploadWrite } from '@/api/baby/writeoff.js'
export default {
    data () {
        return {
            loading: false,
            list: [
                {
                    used_code: '',
                    card_no: ''
                }
            ],
            writeOffDialog: false,
            uploadDialog: false,
            fileList: [],
            show_list: [],
            file: null
        }
    },
    methods: {
        // 关闭批量上传
        closeUpload () {
            this.fileList.splice(0, this.fileList.length);
            this.file = null;
        },
        onAdd () {
            this.list.push({code: '', idCard: ''});
        },
        onRemove (index) {
            this.list.splice(index, 1);
        },
        // 核销
        writeOff () {
            this.show_list.splice(0,this.show_list.length);
            for(let i = 0; i < this.list.length; i++) {
                if(!this.list[i].used_code) {
                    this.$message.warning('请填写核销码！')
                    return
                }
                if (!this.list[i].card_no) {
                    this.$message.warning('请填写身份证！')
                    return
                }
                this.show_list.push(this.list[i].used_code)
            }
            this.writeOffDialog = true;
        },
        // 确定核销
        sureWriteOff () {
            let data = {
                method: '1',
                shop_id: JSON.parse(sessionStorage.getItem('userid'))*1 || 0,
                code_info: JSON.stringify(this.list)
            }
            this.loading = true;
            writeOff(data)
                .then(res => {
                    if (res.data.code == 0) {
                        this.writeOffDialog = false;
                        this.list.splice(0, this.list.length);
                        this.list.push({ used_code: '', card_no: '' })
                        this.$message.success('已核销！')
                    } else {
                        if (typeof res.data.msg == 'object') {
                            let list = res.data.msg.map(item => {
                                return item.msg
                            });
                            this.$message.error(list.join('、'));
                            this.writeOffDialog = false;
                        } else {
                            this.$message.error(res.msg);
                        }
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        },
        // 点击批量上传
        batchUpload () {
            this.uploadDialog = true;
        },
        upLoadFile () {
            if(!this.file) {
                return
            }
            let formData = new FormData();
            formData.append('file', this.file);
            this.loading = true;
            uploadWrite(formData)
                .then(res => {
                    if (res.data.code == 0) {
                        this.$message.success('已核销')
                    } else {
                        if (typeof res.data.msg == 'object') {
                            let list = res.data.msg.map(item => {
                                return item.used_code
                            });
                            this.$message.error(`未查询到电子卷：${list.join('、')}，请确认后再进行核销！`);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }
                })
                .catch(err =>{
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handleChange(file) {
            this.file = file.raw;
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        fileSubmit() {
            //没有选取文件弹出提醒
            if (this.$refs.upload.uploadFiles.length < 1) {
                this.$message.warning("请先选择一个文件");
            } else {
                this.upLoadFile();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #i-want {
        background: #f0f0f0;
        min-height: 800px;
        min-width: 1200px;
        .title {
            box-shadow: 0px 0px 8px 0px rgba(100, 100,100, .17);
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
        }
        .content {
            margin: 24px;
            background: #fff;
            min-height: 660px;
            padding: 24px 48px 48px 48px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .form-body { 
                margin-top: 24px;
                display: flex;
                align-items: center;
            }
        }
    }

    .icon_cursor {
        font-size: 30px; 
        color: #409EFF;
        &:hover {
            color: #909399;
        }
    }
    .icon_cursor2 {
        font-size: 30px; 
        color: #F56C6C;
        &:hover {
            color: #909399;
        }
    }

    .bottom-button {
        display: flex;
        flex-direction: column;
    }

    .circle-plus-outline, .remove-outline {
        margin-left: 12px;
    }

    ::v-deep .dialog1 {
        .el-dialog__body {
            min-height: 100px;
        }
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    ::v-deep .el-message-box__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        min-height: 280px;
    }

    ::v-deep .upload-demo {
        position: relative;
    }

    ::v-deep .el-upload-list {
        width: 200px;
        height: 200px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0px);
        margin-top: 15px;
    }
    
    ::v-deep .el-upload-list__item {
        background: #f5f5f5;
        padding: 15px;
        margin-top: 0px;
    }
    
    ::v-deep .el-upload-list__item-name {
        text-align: center;
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
    }
    
    ::v-deep .el-icon-document {
        font-size: 70px;
        margin-right: 0px;
    }

    ::v-deep .el-dialog__body {
        .el-icon-close {
            background: #f00;
            border-radius: 15px;
            font-size: 12px;
            color: #fff;
            padding: 5px;
            top: -5px;
            right: -5px;
            display: block;
        }
    }
</style>